import * as types from "../../actionTypes";
import { getAppointments } from "./appointments";
import { toast } from "../../../UIComponents/Toast";
import { createPatientToggle } from "./createPatient";
import { newPatientModalToggle } from "./createPatient";
import { client } from "../../../utils/axios";

const addAppointmentLoading = () => ({
  type: types.ADD_APPOINTMENT_LOADING,
});

const addAppointmentSuccess = (data) => ({
  type: types.ADD_APPOINTMENT_SUCCESS,
  payload: data,
});
const addAppointmentFail = (error) => ({
  type: types.ADD_APPOINTMENT_FAIL,
  payload: error,
});

// let url = baseUrl();
export const addAppointment = (data) => {
  return function (dispatch) {
    dispatch(addAppointmentLoading());
    client
      .post(
        `/visit/add-appointment`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(addAppointmentSuccess(resp.data));
        dispatch(getAppointments({ scheduledTime: data.scheduledTime }));
        toast.success("Appointment Added Successfully");
        dispatch(createPatientToggle(false));
      })
      .catch((error) => {
        dispatch(addAppointmentFail(error));
        toast.error(`${error.response.data.message}`);
        dispatch(createPatientToggle(true));
      });
  };
};

export const searchCreateAppointment = (data) => {
  return function (dispatch) {
    dispatch(addAppointmentLoading());
    client
      .post(
        `/visit/add-appointment`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(addAppointmentSuccess(resp.data));
        dispatch(getAppointments({ scheduledTime: data.scheduledTime }));
        toast.success("Appointment Added Successfully");
        dispatch(newPatientModalToggle(false));
      })
      .catch((error) => {
        dispatch(addAppointmentFail(error));
        dispatch(newPatientModalToggle(true));
        toast.error(`${error.response.data.message}`);
      });
  };
};
